import React, { useEffect, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import urlWithEventHubParams from "enterprise-integrations/helpers/urlWithEventHubParams";
import { ApiRoutes } from "./common/Routes";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  var _a, _b, _c;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { salesforceClientSecret } = formData;
  const [SalesforceValidationStatus, setSalesforceValidation] = useFetch(
    null,
    onSubmit,
    "POST",
    {
      salesforce_client_id: ((_a = formData == null ? void 0 : formData.salesforceClientId) == null ? void 0 : _a.value) || "",
      salesforce_client_secret: ((_b = formData == null ? void 0 : formData.salesforceClientSecret) == null ? void 0 : _b.value) || "",
      salesforce_base_url: ((_c = formData == null ? void 0 : formData.salesforceBaseUrl) == null ? void 0 : _c.value) || ""
    },
    urlWithEventHubParams
  );
  useEffect(() => {
    setSalesforceValidation(null);
    if (SalesforceValidationStatus.error) {
      setFormError({
        full_message: SalesforceValidationStatus.error,
        nice_message: t("salesforce.authorize.connection_error")
      });
    }
    return () => {
      setFormError(null);
    };
  }, [SalesforceValidationStatus.error, setSalesforceValidation, t]);
  const handleSubmit = () => {
    setSalesforceValidation(ApiRoutes.INTEGRATIONS.Salesforce.CHECK_CREDENTIALS);
  };
  const isFormValid = formValidation.isFormValid(
    ["salesforceName", "salesforceClientId", "salesforceClientSecret", "salesforceBaseUrl"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: isFormValid,
      loading: SalesforceValidationStatus.loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "salesforceName",
        type: "text",
        fieldData: formData.salesforceName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: salesforceClientSecret == null ? void 0 : salesforceClientSecret.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "salesforceBaseUrl",
        type: "text",
        fieldData: formData.salesforceBaseUrl,
        onChange,
        label: t("salesforce.authorize.base_url"),
        help: t("salesforce.authorize.base_url_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "salesforceClientId",
        type: "text",
        fieldData: formData.salesforceClientId,
        onChange,
        label: t("salesforce.authorize.consumer_key"),
        help: t("salesforce.authorize.consumer_key_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "salesforceClientSecret",
        type: "password",
        onChange,
        fieldData: formData.salesforceClientSecret,
        help: t("salesforce.authorize.consumer_secret_help"),
        label: t("salesforce.authorize.consumer_secret"),
        required: true
      }
    )
  );
};
export default StepAuthorize;
